import Plugin from '@ckeditor/ckeditor5-core/src/plugin';
import ButtonView from '@ckeditor/ckeditor5-ui/src/button/buttonview';
import Icon from './customButtonStructureTreeIcon.svg';

export class CustomButtonStructureTree extends Plugin {
  init() {
    const editor = this.editor;

    // このプラグイン用の設定を取得
    // getIsOpen: ダイアログが表示されているかどうかを取得する関数
    // setIsOpen: ダイアログの表示状態をセットする関数。
    // setUpdateButtonFunction: このボタンの更新が必要なときに呼ばれる関数をセットする関数。
    const structureTreeConfig = editor.config.get('structureTree');
    if (structureTreeConfig) {
      const getIsOpen = structureTreeConfig.getIsOpen;
      const setIsOpen = structureTreeConfig.setIsOpen;
      const setUpdateButtonFunction = structureTreeConfig.setUpdateButtonFunction;
      if (getIsOpen && setIsOpen) {
        editor.ui.componentFactory.add('customButtonStructureTree', () => {
          const button = new ButtonView();

          button.set({
            label: editor.i18n.t('構造ツリー'),
            icon: Icon,
            withText: true,
          });

          /**
           * 初期状態をセット。
           */
          button.isOn = getIsOpen();

          /**
           * ボタンが押されたときの動作を記述。
           */
          button.on('execute', () => {
            // ダイアログの表示状態を取得
            const isOpen = getIsOpen();

            setIsOpen(!isOpen);

            button.isOn = !isOpen;
          });

          /**
           * 更新が必要な時のための関数をセット。
           */
          if (setUpdateButtonFunction) {
            setUpdateButtonFunction((isOn) => {
              // ボタンがオンかどうかを設定
              button.isOn = isOn;
            });
          }

          return button;
        });
      }
    }
  }
}
